import { trackMainView } from './main';

export const pageView = {
	main: trackMainView,
};
